import { useCallback } from 'react';

import { useAPI } from '@hooks';

import { resendCode } from '../@slices';

export default () => useAPI(useCallback(() => resendCode.action(), []));
